__turbopack_context__.v({
  "scrollable": "Z7IArq_scrollable",
});
